module.exports = __webpack_public_path__ + "img/Quality.28a4436d.png";